import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function merchantsReducer(
  state = initialState.merchant,
  action
) {
  switch (action.type) {
    case types.GET_MERCHANT_DETAILS_SUCCESS:
      return action.merchant;
    case types.GET_MERCHANT_DETAILS_FAILED:
      return action.error;
    default:
      return state;
  }
}
